<template>
  <div class="star-rating">
    <span
      v-for="index in maxStars"
      :key="index"
      class="star"
      :class="{ 'half': allowHalfStars && isHalfStar(index), 'full': isFullStar(index) }"
      :style="{ fontSize: starSize + 'px' }"
      @click="setRating(index, $event)"
      @mousemove="setHoverRating(index, $event)"
      @mouseleave="resetHoverRating"
    >
      ★
    </span>
    <div class="rating-value">{{ rating }}</div>
  </div>
</template>

<script>
export default {
  props: {
    // Количество звезд (по умолчанию 5)
    maxStars: {
      type: Number,
      default: 5,
    },
    // Размер звезд (по умолчанию 24px)
    starSize: {
      type: Number,
      default: 24,
    },
    // Разрешить половинчатые звезды (по умолчанию false)
    allowHalfStars: {
      type: Boolean,
      default: false,
    },
    // Значение рейтинга (для v-model)
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      hoverRating: 0,
      isHovering: false,
    };
  },
  computed: {
    rating: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue); // Вызываем событие input для v-model
      },
    },
  },
  methods: {
    setRating(index, event) {
      if (this.allowHalfStars) {
        const starWidth = event.target.offsetWidth;
        const clickPosition = event.offsetX;
        if (clickPosition < starWidth / 2) {
          this.rating = index - 0.5; // Половинчатая звезда
        } else {
          this.rating = index; // Полная звезда
        }
      } else {
        this.rating = index; // Только полные звезды
      }
      this.isHovering = false;
    },
    setHoverRating(index, event) {
      if (this.allowHalfStars) {
        const starWidth = event.target.offsetWidth;
        const hoverPosition = event.offsetX;
        if (hoverPosition < starWidth / 2) {
          this.hoverRating = index - 0.5;
        } else {
          this.hoverRating = index;
        }
      } else {
        this.hoverRating = index;
      }
      this.isHovering = true;
    },
    resetHoverRating() {
      this.hoverRating = this.rating;
      this.isHovering = false;
    },
    isHalfStar(index) {
      return this.isHovering
        ? this.hoverRating >= index - 0.5 && this.hoverRating < index
        : this.rating >= index - 0.5 && this.rating < index;
    },
    isFullStar(index) {
      return this.isHovering
        ? this.hoverRating >= index
        : this.rating >= index;
    },
  },
};
</script>

<style scoped src="./starrating.css"></style>


// WEBPACK FOOTER //
// StarRating.vue?1d5ddf46